export const REPORTING_TRACKER = 'reporting-tracker';
export const NO_PRIMARY_TRACKER = 'no-primary-tracker';